import angular from "angular";
angular.module("cardspotWeb.areas.lookupCustomer", []);